import { PlayCircle } from 'lucide-react';
import { usePageContext } from '../usePageContext.ts';
import { SETUP_STEP_ICONS } from './setup-icons.ts';
import { TRACKED_STEP_IDS } from './setup-progress.ts';
import type { StepViewProps } from './step-flow.ts';
import styles from './Setup.module.css';

export const WelcomeStep = ({ flow, guideUrl }: StepViewProps) => {
  const { t } = usePageContext();
  return (
    <form
      id={flow.formId}
      className={styles['stack']}
      onSubmit={(event) => {
        event.preventDefault();
        flow.submit(() => Promise.resolve());
      }}
    >
      {guideUrl === null ? null : (
        <a className={styles['video']} href={guideUrl} target="_blank" rel="noopener noreferrer">
          <PlayCircle size={20} aria-hidden="true" />
          {t('setup.video')}
        </a>
      )}
      <ul className={styles['cards']}>
        {TRACKED_STEP_IDS.map((id) => {
          const Icon = SETUP_STEP_ICONS[id];
          return (
            <li key={id} className={styles['card']}>
              <span className={styles['cardIcon']} aria-hidden="true">
                <Icon size={20} />
              </span>
              <strong>{t(`setup.step_${id}`)}</strong>
              <span className={styles['muted']}>{t(`setup.step_${id}Card`)}</span>
            </li>
          );
        })}
      </ul>
    </form>
  );
};
